jQuery(function ($){

  lightGallery(document.getElementById('lightgallery'), {
    speed: 500,
    nextHtml: '<svg width="56" height="27" viewBox="0 0 56 27" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M55.1317 12.9043L43.3028 -6.55518e-06L42.5656 0.675718L53.7752 12.9043L-8.845e-06 12.9043L-8.75758e-06 13.9043L53.7757 13.9043L42.5656 26.1335L43.3028 26.8092L55.1323 13.9043L55.1332 13.9033L55.5903 13.4046L55.1332 12.9059L55.1332 12.9043L55.1317 12.9043Z" fill="#C8AD73"/>',
    prevHtml: '<svg width="57" height="28" viewBox="0 0 57 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.76681 14.0669L14.435 1.33803L13.6978 0.662306L1.41024 14.0669L13.6978 27.4715L14.435 26.7958L2.76681 14.0669Z" fill="#C8AD73"/><path fill-rule="evenodd" clip-rule="evenodd" d="M2.86676 13.5671L57 13.5671L57 14.5671L2.86676 14.5671L2.86676 13.5671Z" fill="#C8AD73"/></svg>',
    mode: 'lg-fade'
  });

});

